import { findFirstNonEmptyString } from "@product/scmp-sdk";
import first from "lodash/first";
import type { FunctionComponent } from "react";
import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import { checkIfNewsSectionInFirstIndex } from "~/lib/section";
import type { topBannerContent$key } from "~/queries/__generated__/topBannerContent.graphql";

import { Container, StyledAdSlot, Wrapper } from "./styles";

type Props = {
  reference: topBannerContent$key;
};

export const TopBanner: FunctionComponent<Props> = ({ reference }) => {
  const content = useFragment(
    graphql`
      fragment topBannerContent on Content {
        advertZone(version: 2)
        sections {
          value {
            ...helpersFilterSection
            entityId
          }
        }
      }
    `,
    reference,
  );

  const firstSection = useMemo(() => first(content.sections)?.value ?? [], [content.sections]);
  const sectionForAdslot = useMemo(
    () =>
      first(
        firstSection.filter((section, index) => !checkIfNewsSectionInFirstIndex(section, index)),
      ),
    [firstSection],
  );

  return (
    <Container>
      <Wrapper>
        <StyledAdSlot
          adUnit="m_banner3a"
          sizes={[[300, 100], [320, 100], [300, 50], [320, 50], "fluid"]}
          targeting={{
            scsid: [sectionForAdslot?.entityId ?? ""],
          }}
          zone={findFirstNonEmptyString(content.advertZone, "default")}
          withBackground
        />
      </Wrapper>
    </Container>
  );
};

TopBanner.displayName = "TopBanner";
